// extracted by mini-css-extract-plugin
module.exports = {"menu":"menu-module--menu--3X5d9","links":"menu-module--links--2HEVn","audio":"menu-module--audio--FDVh7"};